<template>
    <table class="w-full">
        <thead class="text-2xl text-output-primary">
            <tr class="text-left">
                <th
                    v-for="(header, index) in table.headers"
                    :key="index"
                    :class="[{ 'text-output-secondary': index === 0 }]"
                >
                    {{ header }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr
                v-for="(rowData, rowIndex) in table.data"
                :key="rowIndex"
                :class="[
                    'text-2xl',
                    {
                        'text-output-primary': rowIndex % 2 !== 0,
                        'text-white bg-output-primary': rowIndex % 2 === 0
                    }
                ]"
            >
                <template v-for="(cellData, cellIndex) in rowData">
                    <td
                        v-if="typeof cellData !== 'boolean'"
                        :key="cellIndex"
                        class="px-2 py-1"
                    >
                        {{ cellData }}
                    </td>
                    <td
                        v-else
                        :key="cellIndex"
                        :class="{
                            'text-output-primary': rowIndex % 2 !== 0,
                            'text-white bg-output-primary': rowIndex % 2 === 0
                        }"
                    >
                        <slot
                            v-bind:cell="{
                                index: cellIndex,
                                content: cellData
                            }"
                            name="htmlContent"
                        >
                        </slot>
                    </td>
                </template>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    props: {
        table: {
            type: Object,
            required: true
        }
    }
};
</script>

<style></style>
